import { Chip } from "@mui/material";
import React, { useMemo,memo } from "react";
import GaugeChart from "react-gauge-chart";

const chipStyle = {
  color: "#d3f4fe",
  minWidth: "50px",
};

const OccupancyUtilizationKPI = memo(({ avgUtil, maxUtil, minUtil }) => {
  const percentage = useMemo(() => {
    if (avgUtil >= 0 && avgUtil <= 19) return 0.2;
    if (avgUtil > 19 && avgUtil <= 49) return 0.5;
    if (avgUtil > 49 && avgUtil <= 100) return 0.8;

    return 0.2;
  }, [avgUtil]);

  return (
    <>
    
      {/* <span>{avgUtil!=='N/A'&&(avgUtil>100?100:avgUtil.toFixed(0))}%</span> */}
      <p className="card-value">Space Utilization</p>
      <GaugeChart
        id="gauge-chart4"
        animate={false}
        colors={["#f00", "#ffff00", "lawngreen"]}
        arcPadding={0.1}
        cornerRadius={4}
        percent={percentage} // Max 100
        hideText="true"
        style={{ width: "110px" }}
        className="dashboard-health-title"
      />
      <div className="d-flex justify-content-start align-items-start gap-2">
        {/* <div className="d-flex justify-content-center align-items-center card-value">
          <Chip label="Max" sx={chipStyle} />
          <p className="m-1 p-0">{maxUtil}%</p>
        </div>
        <div className="d-flex justify-content-center card-value">
          <Chip label="Min"  sx={chipStyle}  />
          <p className="m-1 p-0">{minUtil}%</p>
        </div> */}

        <div className="d-flex justify-content-center align-items-center card-value-v2 gap-2">
          <div className="p-0">🔴0-19</div>
          <div className="p-0">🟡20-49</div>
          <div className="p-0">🟢50-100</div>
        </div>
      
      </div>
    </>
  );
});

export default OccupancyUtilizationKPI;
